import owaEmptyState_lib_svg_Dark_illustration_moon_errorSvg from 'owa-empty-state/lib/svg/Dark/illustration_moon_error.svg';
import owaEmptyState_lib_svg_Light_illustration_moon_errorSvg from 'owa-empty-state/lib/svg/Light/illustration_moon_error.svg';
import EmptyState from 'owa-empty-state/lib/components/EmptyState';
import { getIsDarkTheme } from 'owa-fabric-theme';
import * as React from 'react';
import { observer } from 'mobx-react-lite';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7034 (11,5): Variable 'ERROR_STATE' implicitly has type 'any' in some locations where its type cannot be determined.
// @ts-expect-error
let ERROR_STATE;
import styles from './AppHostErrorState.scss';

function initializeDisplayIconsForEmptyState() {
    if (getIsDarkTheme()) {
        ERROR_STATE = owaEmptyState_lib_svg_Dark_illustration_moon_errorSvg;
    } else {
        ERROR_STATE = owaEmptyState_lib_svg_Light_illustration_moon_errorSvg;
    }
}

export default observer(function AppHostErrorState() {
    initializeDisplayIconsForEmptyState();
    return (
        <EmptyState
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7005 (29,19): Variable 'ERROR_STATE' implicitly has an 'any' type.
            // @ts-expect-error
            icon={ERROR_STATE}
            //TODO: 120056 App host loc strings
            mainMessage={'There was a problem reaching this app'}
            classNames={{
                container: styles.container,
            }}
            iconSize={160}
        />
    );
});
